module.exports = __webpack_public_path__ + "img/zfb.ba4dbec5.jpg";